export const convertDateToAPIFormat = (dateStr: string | Date): string => {
  // Check if already in YYYYMMDD format (8 digits)
  if (typeof dateStr === "string" && /^\d{8}$/.test(dateStr)) {
    return dateStr;
  }

  // Try to parse MM/DD/YYYY format (or a Date instance directly)
  const date = new Date(dateStr);

  if (isNaN(date.getTime())) {
    // If parsing fails, return the original input as a string
    return String(dateStr);
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}${month}${day}`;
};
